import { useEffect, useMemo, useState } from 'react'

type FigureThumbProps = {
  src?: string | null
  alt?: string
  size?: number
  variant?: 'circle' | 'rounded'
  fallbackText?: string
  className?: string
}

const buildInitials = (value?: string | null) => {
  if (!value) return 'PiT'
  const parts = value.trim().split(/\s+/)
  const initials = parts.slice(0, 2).map((part) => part.charAt(0).toUpperCase()).join('')
  return initials || 'PiT'
}

const FigureThumb = ({ src, alt = 'Figure portrait', size = 48, variant = 'circle', fallbackText, className }: FigureThumbProps) => {
  const [errored, setErrored] = useState(false)
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    setErrored(false)
    setLoaded(false)
  }, [src])

  const displayInitials = useMemo(() => buildInitials(fallbackText || alt), [fallbackText, alt])
  const shouldShowFallback = !src || errored

  const classes = ['figure-thumb', variant, className].filter(Boolean).join(' ')

  return (
    <span className={classes} style={{ width: size, height: size }}>
      {shouldShowFallback ? (
        <span className="figure-thumb-monogram">{displayInitials}</span>
      ) : (
        <img
          className={`figure-thumb-image${loaded ? ' is-loaded' : ''}`}
          src={src ?? undefined}
          alt={alt}
          width={size}
          height={size}
          loading="lazy"
          decoding="async"
          fetchPriority="low"
          style={{ objectFit: 'cover', width: size, height: size }}
          onError={() => setErrored(true)}
          onLoad={() => setLoaded(true)}
        />
      )}
    </span>
  )
}

export default FigureThumb
